import { leftNavClickTypes, modalTypes } from './types';

const dashboardActions = {
  clickOnLeftHome: () => ({
    type: leftNavClickTypes.CLICK_HOME,
  }),
  clickOnLeftSchools: () => ({
    type: leftNavClickTypes.CLICK_SCHOOLS,
  }),
  clickOnLeftExperts: () => ({
    type: leftNavClickTypes.CLICK_EXPERTS,
  }),
  clickOnLeftGroups: () => ({
    type: leftNavClickTypes.CLICK_GROUPS,
  }),
  clickOnLeftArticles: () => ({
    type: leftNavClickTypes.CLICK_ARTICLES,
  }),
  selectTeamModalOpen: (payload: boolean) => ({
    type: modalTypes.SELECTED_TEAM_MODAL_OPEN,
    payload,
  }),
  setModalAction: (payload: string | null) => ({
    type: modalTypes.SET_MODAL_ACTION,
    payload,
  }),
};
export default dashboardActions;
